import { connect } from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';

import { fetchDashboard } from '../actions';
import Dashboard from '../components/Dashboard';
import { getDeletedBarbers } from '../../../barbers/actions';

const mapStateToProps = state => ({
  shop: state.auth.shop,
});

const mapDispatchToProps = { getDeletedBarbers, fetchDashboard };

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    getAllDeletedBarbers: props => () => props.getDeletedBarbers(props.shop),
  }),
  lifecycle({
    componentDidMount() {
      this.props.getAllDeletedBarbers();
    },
  }),
)(Dashboard);
